import { gql } from '@apollo/client';
import { TaxTransactionSyncInfo } from '../fragments';

export default gql`
  query TaxTransactionSyncs(
    $limit: Int
    $states: [String!]
    $transactionKind: String
    $destinationState: String
    $reportableFrom: DateTimeScalar
    $reportableTo: DateTimeScalar
  ) {
    taxTransactionSyncs(
      limit: $limit
      states: $states
      transactionKind: $transactionKind
      destinationState: $destinationState
      reportableFrom: $reportableFrom
      reportableTo: $reportableTo
    ) {
      ...TaxTransactionSyncInfo
    }
    taxTransactionSyncSummary {
      totalCount
      pendingCount
      processingCount
      succeededCount
      retryableCount
      failedCount
      mismatchedCount
      staleProcessingCount
      reportingEnabled
    }
  }
  ${TaxTransactionSyncInfo}
`;
